import React from 'react';
import LegalLayout from '../components/LegalLayout';

const TermsOfService = () => {
  // Obtenir la date du jour au format français
  const today = new Date();
  const formattedToday = today.toLocaleDateString('fr-FR', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <LegalLayout 
      title="Conditions Générales d'Utilisation (CGU)"
      lastUpdated={formattedToday}
    >
      <div className="space-y-8">
        {/* Historique des versions */}
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Historique des versions
          </h2>
          <div className="bg-amber-50 p-6 rounded-xl border border-amber-200">
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="inline-block bg-amber-100 rounded-full p-1 mr-2">📝</span>
                <div>
                  <p className="font-medium">26 février 2025</p>
                  <p className="text-sm">Version initiale des Conditions Générales d'Utilisation</p>
                </div>
              </li>
              <li className="flex items-start">
                <span className="inline-block bg-amber-100 rounded-full p-1 mr-2">📝</span>
                <div>
                  <p className="font-medium">{formattedToday}</p>
                  <p className="text-sm">Ajout de la politique de mise à jour avec préavis de 30 jours</p>
                </div>
              </li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Présentation
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100 space-y-4">
            <p className="text-gray-600">
              Clicdroits.info (ci-après le « Site ») est exploité par <span className="font-medium text-gray-800">M. Abderauf Kakhlaui</span>, 
              entrepreneur individuel actuellement <span className="font-medium text-gray-800">en voie d'immatriculation</span> au Québec. 
              L'immatriculation est planifiée d'ici <span className="font-medium">septembre 2025</span>, conformément à la Loi sur la publicité légale des entreprises.
              Les présentes Conditions générales d'utilisation (CGU) encadrent votre accès et votre utilisation du Site.
            </p>
            <p className="text-gray-600">
              À ce jour, le Site est proposé à titre de <span className="font-medium text-gray-800">ressource informative gratuite</span>. 
              L'immatriculation visée accompagnera le lancement éventuel de fonctionnalités payantes optionnelles. 
              L'accès gratuit aux informations essentielles demeurera toutefois garanti.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Acceptation des CGU
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <p className="text-gray-600">
              En naviguant sur le Site ou en créant un compte, vous acceptez l'intégralité de ces Conditions générales d'utilisation. 
              Si vous n'êtes pas d'accord avec l'une quelconque de ces conditions, veuillez cesser d'utiliser le Site.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Services offerts
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <ul className="space-y-4 text-gray-600">
              <li>
                <span className="font-medium text-gray-800">Informations juridiques générales</span> : Nous fournissons des informations d'ordre juridique, 
                basées sur des textes de loi et d'autres sources.
              </li>
              <li>
                <span className="font-medium text-gray-800">Estimations</span> : Nous pouvons générer, via un algorithme propriétaire, des estimations 
                de coûts ou de valeurs liés à certaines démarches ou situations. Vous pouvez conserver ces estimations en effectuant 
                des captures d'écran et, à partir d'avril 2025, les télécharger lorsque la fonctionnalité sera disponible.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Absence de conseils juridiques
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <div className="space-y-4 text-gray-600">
              <div>
                <p className="font-medium text-gray-800 mb-2">Informations vs. conseils</p>
                <p>Notre service ne fournit pas de conseils juridiques. Nous offrons des informations générales, des listes de documents possibles, ainsi que des estimations de coûts.</p>
              </div>
              
              <div>
                <p className="font-medium text-gray-800 mb-2">Exemples :</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Ce que nous faisons : informer sur les procédures, énumérer des documents potentiels, proposer une estimation approximative.</li>
                  <li>Ce que nous ne faisons pas : choisir la stratégie juridique, évaluer précisément vos chances de succès devant un tribunal, vous représenter ou vous défendre en justice.</li>
                </ul>
              </div>
              
              <div>
                <p className="font-medium text-gray-800 mb-2">Précision</p>
                <p>Même un avocat ne peut garantir un résultat, car les décisions finales relèvent des tribunaux. Les informations fournies ici doivent être complétées par un professionnel en exercice si vous avez besoin de conseils adaptés à votre situation.</p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Utilisation du Site
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <ul className="space-y-4 text-gray-600">
              <li>
                <span className="font-medium text-gray-800">Exactitude des données</span> : Nous mettons tout en œuvre pour que les informations diffusées soient à jour, mais il peut exister des erreurs ou des inexactitudes.
              </li>
              <li>
                <span className="font-medium text-gray-800">Responsabilité de l'utilisateur</span> : Vous demeurez responsable de l'usage que vous faites des informations. Nous recommandons de consulter un avocat pour les cas spécifiques ou complexes.
              </li>
              <li>
                <span className="font-medium text-gray-800">Respect des lois</span> : Vous vous engagez à respecter les lois en vigueur au Québec ainsi que tout droit tiers dans votre utilisation du Site.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Limitation de responsabilité
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <ul className="space-y-4 text-gray-600">
              <li>
                <span className="font-medium text-gray-800">Aucune garantie</span> : Les services de Clicdroits.info sont offerts « tels quels », sans garantie, expresse ou implicite.
              </li>
              <li>
                <span className="font-medium text-gray-800">Exclusion de responsabilité</span> : Dans les limites permises par la loi, nous déclinons toute responsabilité pour tout dommage direct ou indirect lié à l'utilisation de nos informations ou estimations.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Modifications des CGU
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <ul className="space-y-4 text-gray-600">
              <li>
                <span className="font-medium text-gray-800">Préavis de modification</span> : En cas de modification importante de nos CGU ou de notre politique de confidentialité, nous nous engageons à vous informer par un avis visible sur notre site au moins 30 jours avant l'entrée en vigueur des changements. Ce délai vous permettra de prendre connaissance des modifications et de décider si vous souhaitez continuer à utiliser nos services.
              </li>
              <li>
                <span className="font-medium text-gray-800">Nature des avis</span> : Ces avis seront clairement visibles sur notre page d'accueil et/ou lors de votre connexion, et indiqueront la nature des changements apportés.
              </li>
              <li>
                <span className="font-medium text-gray-800">Mises à jour mineures</span> : Les modifications mineures ou techniques pourront être effectuées sans préavis, mais seront documentées dans l'historique des versions.
              </li>
              <li>
                <span className="font-medium text-gray-800">Fin d'utilisation</span> : Si vous n'acceptez pas les modifications, vous devez cesser d'utiliser le Site.
              </li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Loi applicable
          </h2>
          <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
            <p className="text-gray-600">
              <span className="font-medium text-gray-800">Compétence</span> : Les présentes CGU sont régies par les lois du Québec et tout litige relèvera des tribunaux de la province de Québec.
            </p>
          </div>
        </section>
      </div>
    </LegalLayout>
  );
};

export default TermsOfService;
